// some cybersource hack from Slack 15.5.

const paymentMethodRadios = document.querySelectorAll('input[name="payment_method"]');
const cybersourceCC = document.querySelector('.payment_box.payment_method_cybersource_credit_card');
paymentMethodRadios.forEach(radio => {
radio.addEventListener('change', function(event) {
  // Get the value of the selected radio input
  const selectedPaymentMethod = event.target.value;
  if(selectedPaymentMethod === 'cybersource_credit_card') {
    cybersourceCC.style.display = 'block';
  } else {
    cybersourceCC.style.display = 'none';
  }
});
});
